<div class="modal-header">
  <h5 class="modal-title">Добавление проблемы</h5>
  <button type="button" class="close" mat-dialog-close style="outline: none">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body property-window form form-horizontal">
  <div class="form-body">
    <div class="form-group row">
      <label class="col-md-3 label-control" for="itemName">Название <span class="danger">*</span></label>
      <div class="col-md-6">
        <input class="form-control" id="itemName" [(ngModel)]="appError.title" type="text" placeholder="Краткое название проблемы или предложения"
               required #itemName="ngModel">
        <ng-container *ngIf="itemName.invalid && (itemName.dirty || itemName.touched)">
          <small class="form-text text-muted danger"
                 *ngIf="itemName.errors.required">это поле обязательно для заполнения</small>
        </ng-container>
      </div>
    </div>
    <div class="form-body">
      <div class="form-group row">
        <label class="col-md-3 label-control" for="itemName">Описание</label>
        <div class="col-md-6">
          <textarea [(ngModel)]="appError.description" rows="5" cols="14" class="form-control"></textarea>
        </div>
      </div>
    </div>
    <div class="form-body">
      <div class="form-group row">
        <label class="col-md-3 label-control" for="itemName">Статус <span class="danger">*</span></label>
        <div class="col-md-6">
          <select [(ngModel)]="appError.status" class="form-control" required #itemType="ngModel">
            <option value="">...</option>
            <option value="Ошибка">Ошибка</option>
            <option value="Предложение">Предложение</option>
          </select>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="modal-footer" style="justify-content: center">
  <button class="btn btn-raised btn-warning mr-1" type="button" mat-dialog-close>
    <i class="ft-x"></i> Закрыть
  </button>
  <button class="btn btn-raised btn-primary" type="button" type="button" (click)="save()">
    <i class="ft-check"></i> Сохранить
  </button>
</div>
